var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgPnpCoast = function SvgImgPnpCoast(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.024 2.2a.8.8 0 0 1 .793.7l.007.1-.001 1.2h4.2a.8.8 0 0 1 .1 1.594l-.1.006h-4.2v3.4h1.7a2.8 2.8 0 0 1 2.795 2.63l.006.17v1a2.8 2.8 0 0 1-2.63 2.795l-.17.005-1.701-.001V17a.8.8 0 0 1-1.593.1l-.006-.1-.001-1.201-4.243.001a.8.8 0 0 1-.1-1.594l.1-.006h4.243v-3.401l-1.7.001a2.799 2.799 0 0 1-2.794-2.63L4.724 8V7a2.8 2.8 0 0 1 2.629-2.795l.17-.005h1.7V3a.8.8 0 0 1 .8-.8zm.799 12h1.7a1.2 1.2 0 0 0 1.194-1.077l.007-.123v-1c0-.621-.473-1.132-1.078-1.194l-.122-.006-1.701-.001V14.2zm-1.6-5V5.8h-1.7A1.2 1.2 0 0 0 6.33 6.877L6.324 7v1a1.2 1.2 0 0 0 1.077 1.194l.123.006h1.699z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#2BB700",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#2A394D",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgPnpCoast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-pnp-coast.6b030ef772d2ae549618ef77bab5f76f.svg";